// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { InternalTeamMemberDTO } from './internal-team-member-dto';

/**
 * 
 * @export
 * @interface OrganizationInternalOwnerDTO
 */
export interface OrganizationInternalOwnerDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationInternalOwnerDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInternalOwnerDTO
     */
    internalTeamMemberId: string;
    /**
     * 
     * @type {InternalTeamMemberDTO}
     * @memberof OrganizationInternalOwnerDTO
     */
    internalTeamMember: InternalTeamMemberDTO;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInternalOwnerDTO
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInternalOwnerDTO
     */
    responsibleFor: OrganizationInternalOwnerDTOResponsibleForEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInternalOwnerDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInternalOwnerDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganizationInternalOwnerDTOResponsibleForEnum {
    SALES = 'SALES'
}



